import React, { memo } from 'react'

import { classnames, Image2 } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOf } from 'prop-types'

import CubeIcon from './Components/CubeIcon/CubeIcon'

const GLYPH_SIZE = {
  large: { height: '40', width: '40' },
  small: { height: '24', width: '24' },
}

// Figma's shared `empty-state-icon`: a gradient badge holding a glyph, centred in
// decorative rings that overflow the badge on every side. Purely decorative, so the
// whole thing is hidden from assistive tech and the surrounding copy carries the meaning.
function EmptyStateIllustration({ glyph = 'cube', size = 'large' }) {
  const isSmall = size === 'small'
  const Glyph = glyph === 'image' ? Image2 : CubeIcon

  return (
    <span
      className={classnames('empty-state-illustration', isSmall && 'empty-state-illustration--small')}
      aria-hidden="true"
    >
      <span
        className={classnames('empty-state-illustration__rings', isSmall && 'empty-state-illustration__rings--small')}
      />
      <span
        className={classnames('empty-state-illustration__badge', isSmall && 'empty-state-illustration__badge--small')}
      >
        <Glyph {...GLYPH_SIZE[size]} />
      </span>
    </span>
  )
}

EmptyStateIllustration.propTypes = {
  glyph: oneOf(['cube', 'image']),
  size: oneOf(['large', 'small']),
}

export default memo(EmptyStateIllustration)
